import { configureCompat } from 'vue';

// bootstrap-vue needs global Vue-2 behaviour, so MODE 2 is pinned globally rather than tightening
// compat flags one by one. Its own module so it's imported, and runs, before configure-vue.ts.
configureCompat({ MODE: 2 });
